const initBackToLinkButton = () => {
    const backToLinkButton = document.querySelector('.gg-back-to-link .wp-block-button__link');

    if (!backToLinkButton) {
        return;
    }

    const referrerLink = document.referrer;

    if (referrerLink) {
        backToLinkButton.setAttribute('href', referrerLink);
    }
};

export default initBackToLinkButton;
